import React from "react";
import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import { UI } from "@/content/site";

export default function ConsulateBanner({ section, lang }) {
  const ui = UI[lang];
  return (
    <section className="gw-consulate">
      <div className="gw-container gw-consulate-inner">
        <div className="gw-consulate-emblem" aria-hidden="true">
          <div className="gw-consulate-seal">
            <Scale size={72} strokeWidth={1.4} />
          </div>
        </div>
        <div className="gw-consulate-content">
          <span className="gw-eyebrow" style={{color: "var(--gw-accent)"}}>
            {lang === "en" ? "Consulado General de México en Dallas" : "Programa PALE"}
          </span>
          <h2>{section.heading}</h2>
          {section.paragraphs?.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
          <Link to={ui.contactUrl} className="gw-btn gw-btn-accent" style={{marginTop: "var(--gw-space-3)"}} data-testid="consulate-cta">
            {lang === "en" ? "Schedule a Consultation" : "Programe una Consulta"}
          </Link>
        </div>
      </div>
      <style>{`
        .gw-consulate {
          background: linear-gradient(135deg, #3B0A14 0%, #7A1B2A 100%);
          color: #FFF9E8;
          padding: var(--gw-space-16) 0;
          position: relative;
          overflow: hidden;
        }
        .gw-consulate::before {
          content: "";
          position: absolute;
          right: -100px; top: -100px;
          width: 400px; height: 400px;
          background: radial-gradient(circle, rgba(212,160,23,0.25) 0%, transparent 70%);
          pointer-events: none;
        }
        .gw-consulate-inner {
          display: grid;
          grid-template-columns: auto 1fr;
          gap: var(--gw-space-10);
          align-items: center;
          position: relative; z-index: 1;
        }
        @media (max-width: 800px) { .gw-consulate-inner { grid-template-columns: 1fr; text-align: center; } }
        .gw-consulate-seal {
          width: 180px; height: 180px;
          border-radius: 50%;
          background: radial-gradient(circle, var(--gw-accent) 0%, #B98812 100%);
          display: flex; align-items: center; justify-content: center;
          color: var(--gw-primary-dark);
          border: 6px solid rgba(255, 249, 232, 0.15);
          box-shadow: 0 12px 40px rgba(0,0,0,0.3);
          position: relative;
        }
        .gw-consulate-seal::after {
          content: "";
          position: absolute; inset: -14px;
          border: 2px dashed rgba(255, 249, 232, 0.3);
          border-radius: 50%;
          animation: gwConsulateRotate 60s linear infinite;
        }
        @keyframes gwConsulateRotate { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @media (max-width: 800px) { .gw-consulate-seal { margin: 0 auto; width: 140px; height: 140px; } }
        @media (prefers-reduced-motion: reduce) {
          .gw-consulate-seal::after { animation: none; }
        }
        .gw-consulate h2 { color: var(--gw-accent); margin-bottom: var(--gw-space-4); }
        .gw-consulate p { color: rgba(255,255,255,0.92); font-size: 1.05rem; }
      `}</style>
    </section>
  );
}
